// extracted by mini-css-extract-plugin
export default {"tooltipBlock":"style_tooltipBlock__nTD8l","header":"style_header__rt-3P","tooltipBlockContent":"style_tooltipBlockContent__LpUv+"};